module.exports = __webpack_public_path__ + "assets/img/activity-time-ae91f097.png";